import React from 'react';

import Header from 'presentation/components/Header.jsx';
import styles from 'presentation/components/styles/ChatClosed.css';

const ChatClosed = ({ closedMessage }) => {
  let message =
    closedMessage ||
    'We want to chat with you, but it’s outside of our office hours. Chat again tomorrow to pick up where we left off.';
  return (
    <div className={styles.chatClosed} data-aid="gladlyChatClosedPane">
      <Header title="Whoops, sorry we missed you!" />
      <div className={styles.chatClosed_body}>{message}</div>
    </div>
  );
};

export default ChatClosed;
